import { Pipe, PipeTransform } from '@angular/core';

import { getLabelKebabCase } from './metric-selector-modal-pipes-utils';

/**
 * Get Metric Scroll Id
 *
 * Create a unique string to identify the metric for scrolling.
 *
 * Value:
 *   metricByCategoryListId: The string identifying which component extending MetricByCategoryListDirective includes
 *     the item to scroll to. This is necessary because more than one of those components can exist on the same page.
 *
 * Params:
 *   metricLabel: A unique string identifying the metric, usually known as `internal_name`.
 *   categoryLabel: The label of the metric's category; this is the broadest way metrics are grouped.
 *   sectionLabel: The label of the metric's section; this is part of a category and can contain individual metrics or
 *     submenus of individual metrics.
 *   menuLabel: The label of the metric's menu, if the metric is part of a submenu. Not all metrics are part of submenus.
 *
 */
@Pipe({
    name: 'getMetricScrollId',
    standalone: false,
})
export class GetMetricScrollIdPipe implements PipeTransform {
    transform(
        metricByCategoryListId: string,
        metricLabel: string,
        categoryLabel: string,
        sectionLabel: string,
        menuLabel?: string
    ): string {
        if (menuLabel) {
            return getLabelKebabCase([metricLabel, categoryLabel, sectionLabel, menuLabel, metricByCategoryListId]);
        }
        return getLabelKebabCase([metricLabel, categoryLabel, sectionLabel, metricByCategoryListId]);
    }
}
